/**
 * PMX — Voce "Black Month" nel menu (desktop mega menu + menu mobile ADR) — PARMAX
 * Riconosce da sola la voce Black: e' quella i cui sottomenu si chiamano "-NN% Etichetta"
 * (es. "-70% Outlet") con dentro i link Donna / Uomo. I link restano quelli del menu Shopify.
 * - Desktop: pannello nero con le fasce sconto affiancate (numero grande, etichetta, Donna | Uomo)
 * - Mobile: pannello unico a righe (un tocco per arrivare alla collezione)
 * - Il nome della voce segue la fase (Black Month / Week / Friday) da window.PMX_PROMO.
 * Stili: assets/pmx-bf-menu.css. Caricato da sections/pmx-bf-style.liquid.
 */
(() => {
  if (window.PMX_MENU_INIT) return;
  window.PMX_MENU_INIT = true;

  const TIER = /^\s*(-\s?\d+\s?%)\s*(.*)$/;
  const BLACK = /black\s+(month|week|friday)/i;
  const P = window.PMX_PROMO || null;
  const html = document.documentElement;

  const phaseName = () => {
    if (!P || !P.n) return '';
    const key = html.getAttribute('data-pmx-phase') || P.key;
    return (P.n[key] || '').trim();
  };
  const titleCase = (s) => String(s).toLowerCase().replace(/(^|\s)\S/g, (m) => m.toUpperCase());
  // "Scopri il Black Month" -> "Scopri il Black Week" ecc.; maiuscolo se l'originale e' maiuscolo
  const withPhase = (text) => {
    const n = phaseName();
    if (!n || !BLACK.test(text)) return text;
    return text.replace(BLACK, (m) => (m === m.toUpperCase() ? n.toUpperCase() : titleCase(n)));
  };
  const el = (tag, cls, text) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  const link = (href, text, cls) => { const a = el('a', cls, text); a.href = href; return a; };

  /* tiers = [{ value, caption, links: [{ href, text }] }] */
  const buildTiers = (tiers, cls) => {
    const ul = el('ul', cls + '__list');
    tiers.forEach((t) => {
      const li = el('li', cls + '__item');
      li.appendChild(el('span', cls + '__value', t.value));
      const body = el('span', cls + '__body');
      if (t.caption) body.appendChild(el('span', cls + '__caption', t.caption));
      const links = el('span', cls + '__links');
      t.links.forEach((l) => links.appendChild(link(l.href, l.text, cls + '__link')));
      body.appendChild(links);
      li.appendChild(body);
      ul.appendChild(li);
    });
    return ul;
  };

  /* ---------- Desktop (mega menu del tema) ---------- */
  const initDesktop = () => {
    document.querySelectorAll('.main-nav > li').forEach((li) => {
      if (li.dataset.pmxMm) return;
      const grid = li.querySelector('.mega-nav__grid, .main-nav__child');
      const nav = grid && grid.querySelector('.child-nav');
      if (!nav) return;
      const tiers = [];
      let extra = null;
      nav.querySelectorAll(':scope > li').forEach((c) => {
        if (c.classList.contains('lg:hidden') || c.classList.contains('adr-feat')) return;
        const head = c.querySelector(':scope > a, :scope > span');
        const title = head ? head.textContent.trim() : '';
        const m = title.match(TIER);
        const subs = c.querySelectorAll(':scope > details .mega-nav__list a, :scope > details a.mega-nav__item');
        if (m && subs.length) {
          tiers.push({ value: m[1].replace(/\s/g, ''), caption: m[2].trim(), links: [...subs].map((a) => ({ href: a.getAttribute('href'), text: a.textContent.trim() })) });
        } else if (head && head.tagName === 'A' && head.getAttribute('href') && head.getAttribute('href') !== '#') {
          extra = { href: head.getAttribute('href'), text: title };
        }
      });
      if (tiers.length < 2) return;
      li.dataset.pmxMm = '1';
      li.classList.add('pmx-mm');
      const top = li.querySelector(':scope > a.main-nav__item, :scope > details > summary');
      const topLink = li.querySelector(':scope > a.main-nav__item');
      const landing = topLink ? topLink.getAttribute('href') : null;
      if (top && BLACK.test(top.textContent)) { top.dataset.pmxMmLabel = top.textContent.trim(); top.textContent = withPhase(top.textContent.trim()); }

      const box = el('div', 'pmx-mmd');
      const head = el('div', 'pmx-mmd__head');
      head.appendChild(el('span', 'pmx-mmd__eyebrow', phaseName() || (top ? top.textContent.trim() : '')));
      const cta = extra || (landing ? { href: landing, text: 'Scopri tutto' } : null);
      if (cta) head.appendChild(link(cta.href, withPhase(cta.text) + ' →', 'pmx-mmd__cta'));
      box.appendChild(head);
      box.appendChild(buildTiers(tiers, 'pmx-mmd'));
      nav.hidden = true;
      nav.after(box);
    });
  };

  /* ---------- Mobile (menu ADR a pannelli) ---------- */
  const initMobile = () => {
    const root = document.getElementById('AdrMM');
    if (!root) return;
    root.querySelectorAll('.adr-mm__panel').forEach((panel) => {
      if (panel.dataset.pmxMm) return;
      const id = panel.getAttribute('data-adr-panel');
      if (!id || id === 'root' || id.includes('-')) return; // solo pannelli di secondo livello
      const tiers = [];
      let extra = null;
      panel.querySelectorAll(':scope > .adr-row').forEach((row) => {
        const lbl = row.querySelector('.adr-row__lbl');
        const title = lbl ? lbl.textContent.trim() : '';
        const m = title.match(TIER);
        const sub = m && row.dataset.adrOpen ? root.querySelector(`[data-adr-panel="${row.dataset.adrOpen}"]`) : null;
        if (sub) {
          const links = [...sub.querySelectorAll('a.adr-row:not(.adr-row--all)')].map((a) => ({ href: a.getAttribute('href'), text: a.textContent.trim() }));
          if (links.length) tiers.push({ value: m[1].replace(/\s/g, ''), caption: m[2].trim(), links });
        } else if (row.tagName === 'A' && !row.classList.contains('adr-row--all') && !extra) {
          extra = { href: row.getAttribute('href'), text: title };
        }
      });
      if (tiers.length < 2) return;
      panel.dataset.pmxMm = '1';
      panel.classList.add('pmx-mmm-panel');
      const ptitle = panel.querySelector('.adr-ptitle');
      if (ptitle) ptitle.textContent = withPhase(ptitle.textContent.trim());
      panel.querySelectorAll(':scope > .adr-row').forEach((r) => { r.hidden = true; });

      const box = el('div', 'pmx-mmm');
      if (extra) box.appendChild(link(extra.href, withPhase(extra.text) + ' →', 'pmx-mmm__cta'));
      box.appendChild(buildTiers(tiers, 'pmx-mmm'));
      (ptitle || panel.querySelector('.adr-back')).after(box);

      // voce di primo livello: nome della fase + "fino al -NN%"
      const opener = root.querySelector(`[data-adr-panel="root"] [data-adr-open="${id}"]`);
      if (opener) {
        opener.classList.add('pmx-mmm-l1');
        const lbl = opener.querySelector('.adr-row__lbl');
        if (lbl) lbl.textContent = withPhase(lbl.textContent.trim());
        const max = Math.max(...tiers.map((t) => parseInt(t.value.replace(/\D/g, ''), 10) || 0));
        if (max && !opener.querySelector('.pmx-mmm-l1__note')) {
          const chev = opener.querySelector('.adr-row__chev');
          opener.insertBefore(el('span', 'pmx-mmm-l1__note', `fino al -${max}%`), chev);
        }
      }
    });
  };

  const run = () => { initDesktop(); initMobile(); };
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run); // sezione ricaricata = DOM nuovo, senza segni
})();
